'use client';

import { useToast } from '@/app/context/toast-provider';
import { updateJobApplicationStatusRequest } from '@/app/utils/handlers/client/jobApplication';
import { LuUserRoundCheck } from 'react-icons/lu';
import { useConfirmDialog } from '../useConfirmDialog/useConfirmDialog';
/**
 * Adding a panel round is the moment a candidate usually enters the Interview stage. Before it, the recruiter is
 * asked whether to move them (which sends that stage's notifications). Either answer continues with the round;
 * dismissing the dialog does neither.
 */
export function useCandidateStatusChange({
  jobApplicationId,
  candidateStatus,
  refreshJobApplicationList
}) {
  const {
    confirm
  } = useConfirmDialog();
  const {
    showErrorToast,
    showSuccessToast
  } = useToast();
  const changeCandidateStatus = async () => {
    try {
      await updateJobApplicationStatusRequest(jobApplicationId, {
        status: 'INTERVIEW'
      });
      showSuccessToast('Candidate status updated to Interview');
      refreshJobApplicationList?.();
    } catch (error) {
      showErrorToast(error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong');
      throw error;
    }
  };

  /** Runs `then` straight away for a candidate already in Interview; otherwise after asking. */
  const confirmMoveToInterview = then => {
    if (candidateStatus?.toLowerCase() === 'interview') {
      then();
      return;
    }
    confirm({
      pattern: 'grid-focused',
      // A person with a check: the candidate moving on to the next stage.
      icon: LuUserRoundCheck,
      title: 'Candidate Status Change',
      content: <>
                    This action will change the status of the candidate to <strong>Interview</strong> stage and send any related notifications.
                </>,
      onConfirm: async () => {
        await changeCandidateStatus();
        await then();
      },
      onCancel: () => {
        then();
      },
      onClickOutside: () => {
        // Dismissing adds nothing and changes nothing.
      },
      cancelButtonText: "Don't Change",
      confirmButtonText: 'Proceed'
    });
  };
  return {
    confirmMoveToInterview,
    changeCandidateStatus
  };
}